let $a57617e3675f245e$var$randomNumber = Math.floor(Math.random() * 10) + 1;
function $a57617e3675f245e$export$74ff82ccb88f9fb1(value) {
    if (value === $a57617e3675f245e$var$randomNumber) {
        $a57617e3675f245e$var$generateNewNumber();
        return "correct";
    }
    $a57617e3675f245e$var$generateNewNumber();
    return "wrong";
}
function $a57617e3675f245e$var$generateNewNumber() {
    $a57617e3675f245e$var$randomNumber = Math.floor(Math.random() * 10) + 1;
}


const $6f40c3a58f594b58$var$inputRef = document.querySelector(".input");
const $6f40c3a58f594b58$var$buttonRef = document.querySelector(".btn");
$6f40c3a58f594b58$var$buttonRef.addEventListener("click", ()=>{
    const value = Number($6f40c3a58f594b58$var$inputRef.value);
    if (value === 0) {
        $6f40c3a58f594b58$var$inputRef.style.borderColor = "red";
        return;
    }
    const result = (0, $a57617e3675f245e$export$74ff82ccb88f9fb1)(value);
    if (result === "correct") $6f40c3a58f594b58$var$inputRef.style.borderColor = "green";
    else $6f40c3a58f594b58$var$inputRef.style.borderColor = "red";
});


//# sourceMappingURL=hw-parcel-1-rework.517d55da.js.map
